export default __webpack_public_path__ + "static/media/ic_glp_custom.132ada13.svg";